import { useCallback, useState } from 'react';

export function useDisclosure(
  initialState = false,
  callbacks?: { onOpen?: () => void; onClose?: () => void },
) {
  const { onOpen, onClose } = callbacks || {};
  const [opened, setOpened] = useState(initialState);

  const open = useCallback(() => {
    setOpened((prev) => {
      if (!prev && onOpen) onOpen();
      return true;
    });
  }, [onOpen]);

  const close = useCallback(() => {
    setOpened((prev) => {
      if (prev && onClose) onClose();
      return false;
    });
  }, [onClose]);

  const toggle = useCallback(() => {
    if (opened) close();
    else open();
  }, [close, open, opened]);

  return [opened, { open, close, toggle }] as const;
}
